import { PublicPlan } from '@wix/ambassador-pricing-plans-v2-plan/types';

export function orderPlansForMobileView(plans: PublicPlan[], highlightedId: string) {
  const highlightedIndex = plans.findIndex((plan) => plan.id === highlightedId);
  if (highlightedIndex > 0) {
    plans.splice(0, 0, ...plans.splice(highlightedIndex, 1));
  }
  return plans;
}
